import IcoMoon from "react-icomoon";
import iconSet from "../../assets/selection.json";

const Icon = (props) => <IcoMoon iconSet={iconSet} {...props} />;

export default Icon;